/* eslint-disable camelcase */
import { Serializable } from '@core/models';

export class MenuProductChange extends Serializable {
  constructor(menuProductGuid, serviceGuid, groupCodeName, order, isVisible, special, specialFrame) {
    super();
    this.menuProductGuid = menuProductGuid;
    this.serviceGuid = serviceGuid;
    this.groupCodeName = groupCodeName;
    this.order = order;
    this.isVisible = isVisible;
    this.special = special;
    this.specialFrame = specialFrame;
  }

  serialize() {
    return {
      menu_product_guid: this.menuProductGuid,
      service_guid: this.serviceGuid,
      demand_type: this.groupCodeName,
      is_visible: this.isVisible,
      order: this.order,
      special: this.special,
      special_frame: this.specialFrame,
    };
  }
}
